import axios, { AxiosResponse } from 'axios';

export interface IIsinUpload {
    orignazev?: string;
    tempnazev?: string;
    oid?: number;
    id?: number;
    soubor?: { orignazev?: string; tempnazev?: string; oid?: number; id?: number }[];
}

const isinUpload = async (
    method: 'post' | 'get' | 'delete',
    idZadosti: number,
    data?: IIsinUpload,
    idSoubor?: string | number
) => {
    return axios({
        method: method,
        url: `ISIN/${idZadosti}/Soubor${method === 'delete' ? '/' + idSoubor : ''}`,
        data: data
    }).then((resp: AxiosResponse<IIsinUpload>) => resp.data);
};

export enum EIsinRegistraceSouborTyp {
    VYPISOR = 'VYPISOR',
    EMISNIPODMINKY = 'EMISNIPODMINKY',
    POTVRZENIISIN = 'POTVRZENIISIN',
    JINY = 'JINY'
}

export interface IIsinRegistraceSoubor {
    oid?: number;
    typ: EIsinRegistraceSouborTyp;
    tempnazev: string;
    orignazev: string;
}

export const isinRegistraceSoubory = (idZadosti: number | string, data?: IIsinRegistraceSoubor) => {
    return axios({
        method: 'POST',
        url: `ISIN/${idZadosti}/Priloha/`,
        data: data
    });
};

export default isinUpload;
